<template>
    <div>
  
      <section class="content">
        <div class="box info-box">
          
          <div class="box-body">
            <div class="row">
              <div class="col-md-12">
                <h1 class="text-center">THANK YOU!</h1>
                <div class="main-content text-center">
                    <i class="fa fa-check fa-success fa-lg"></i>
                    <p class="main-content__body" data-lead-id="main-content-body">Payment successful.</p>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
  
      </section>
  
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'Phonepe'
  }
  </script>
  <style scoped>
  .red {
    color: red;
  }
  .content {
    padding: 0px;
  }
  .info-box {
      border-radius:10px;
      box-shadow: 0px 0px 4px gray;
    }
    .box-footer {
      border-radius:0px 0px 10px 10px;
    }
  </style>



// WEBPACK FOOTER //
// Phonepe.vue?4591ff70